import { Component, Inject } from '@angular/core';

// libs
import { BaseComponent } from '@eview/core';

export abstract class AppBaseComponent extends BaseComponent {
  /**
   * Define common root app component behavior for all web apps here
   */
}
